import React from 'react';

import BaseInfoBanner from '../BaseInfoBanner';

interface GenericErrorBannerProps {
  hasReload?: boolean;
}

const GenericErrorBanner = ({ hasReload }: GenericErrorBannerProps) => (
  <BaseInfoBanner
    variant="ERROR"
    {...(hasReload
      ? { buttonText: 'Reload page', onClick: () => window.location.reload() }
      : {})}
  >
    Sorry, something went wrong. Please try again. If the problem persists,
    please contact us.
  </BaseInfoBanner>
);

export default GenericErrorBanner;
